
import React from 'react';

const ResultsGridSection = () => {
  return (
    <div className="bg-gray-50 rounded-lg p-8 mb-12 shadow-xl">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-6 text-gray-700">
          <p className="text-xl font-bold text-gray-900">Juan did $100,000 with cold email.</p>
        </div>
        <div className="space-y-6 text-gray-700">
          <p className="text-xl font-bold text-gray-900">37% open rates sending 50,000 emails a day</p>
        </div>
      </div>
      <div className="mt-8 text-center">
        <p className="text-xl font-bold text-gray-900">4,542 inboxes sending up to 700 emails daily each!</p>
      </div>
    </div>
  );
};

export default ResultsGridSection;
